import { Plus, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { eur } from "../lib/api";

const PATTERNS = {
  grow: /\bgrow\b/i,
  "a-bloom": /\b(a\s*bloom|bloom\s*a)\b/i,
  "b-bloom": /\b(b\s*bloom|bloom\s*b)\b/i,
  "pk-065": /\bpk\b/i,
  "bongo-bloom": /\bbongo\b/i,
  compact: /\bcompact\b/i,
};

export const detectProducts = (text, products) =>
  products.filter((p) => PATTERNS[p.id]?.test(text || ""));

export const DiagRecs = ({ text, products }) => {
  const { add, setOpen } = useCart();
  const recs = detectProducts(text, products);
  if (!recs.length) return null;
  const addAll = () => { recs.forEach((p) => add(p, 1, true)); setOpen(true); };
  return (
    <div data-testid="diag-recommendations" className="mt-4 rounded-[8px] border border-[#F2B441]/40 bg-[#F2B441]/5 p-4">
      <p className="font-mono-d text-[11px] tracking-[0.2em] uppercase text-[#F2B441] mb-3">Productos recomendados en este diagnóstico</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {recs.map((p) => (
          <div key={p.id} className="flex items-center gap-3 rounded-[6px] bg-[#0E2A1C] border border-[#F6EEDC]/10 p-2">
            <img src={p.image} alt={p.name} className="w-10 h-12 object-cover rounded-[3px]" />
            <div className="flex-1 min-w-0">
              <p className="font-label text-sm text-[#F6EEDC] truncate">{p.name}</p>
              <p className="font-mono-d text-[11px] text-[#C9D6C2]">{p.variants?.[0]?.size} · {eur(p.variants?.[0]?.price ?? p.price)}</p>
            </div>
            <button data-testid={`diag-add-${p.id}`} onClick={() => add(p)} aria-label={`Añadir ${p.name}`}
              className="w-9 h-9 shrink-0 rounded-full bg-[#F2B441] text-[#0E2A1C] grid place-items-center hover:bg-[#F6EEDC] transition-colors active:scale-95">
              <Plus className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      {recs.length > 1 && (
        <button data-testid="diag-add-all" onClick={addAll}
          className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#F2B441] text-[#0E2A1C] px-5 h-10 text-sm font-bold hover:bg-[#F6EEDC] transition-colors">
          <ShoppingBag className="w-4 h-4" /> Añadir todos al carrito
        </button>
      )}
    </div>
  );
};
